const md = `# Getting Started

Welcome to the **Eyvo Demo Agent** — an internal tool that drives the
live Eyvo procurement app (\`ibuy.cloud\`) via Playwright, records the
session, and assembles a narrated MP4 you can hand to a customer or
prospect in minutes.

## Sign in

Click **Sign in with Google** on the login page.  Your access level is
determined by your role:

| Role | Can do |
|------|--------|
| **Admin** | Everything: edit workflows, share runs, manage users. |
| **Builder** | Edit and run any workflow, share their own runs. |
| **Presenter** | Run any workflow with custom variables, share their own runs. |
| **Viewer** | Read-only: browse workflows, view runs and shared demos. |

If you're not sure what role you have, hover over the pill next to your
name in the top-right corner.

## The 60-second demo

1. Open **Workflows** in the top nav.
2. Pick *Create Requisition — Free-form Line Item*.
3. Hit the **Run** button on the right.
4. Leave the variables on their defaults, pick the **Presentation**
   pacing, leave **Auto-generate narration & MP4** ticked.
5. Watch the progress bar.  Around 90 seconds in the Playwright session
   finishes; ~2 minutes later you'll have a narrated MP4 ready to share.

That's the loop.  Everything else in this guide is variations on it.
`;

export default md;
